// extracted by mini-css-extract-plugin
module.exports = {"container":"errorBoundary_container__gATVg","section":"errorBoundary_section__w7_u_","message":"errorBoundary_message__TmdXQ"};